import React, { Component } from 'react';

import SummarySlide from '../Slides/SummarySlide';

export default class EditContestView extends Component {

    constructor(props) {
        super(props);

        this.state = {

        }

    }

    render() {

        let kpiMapReverse = this.props.kpiMapReverse;
        let kpiField = "reportKpiId";
        let scopeMapReverse = this.props.locationMapReverse;
        let scopeField = "locationId";
        if (this.props.activeContestForm.scope === "group") {
            kpiMapReverse = this.props.masterKpiMapReverse;
            kpiField = "masterKpiId";
            scopeMapReverse = this.props.groupMapReverse;
            scopeField = "groupId";
        }

        return (
            <div className={this.props.className} style={this.props.style}>
                <div className="gc-new-slide-container full">
                    <SummarySlide
                        position={0}
                        slideNumber={0}
                        form={this.props.activeContestForm}
                        kpiField={kpiField}
                        kpiMapReverse={kpiMapReverse}
                        scopeField={scopeField}
                        scopeMapReverse={scopeMapReverse}
                        hasType={false}
                        navMap={{}}
                        navigate={this.setSlide}
                        noEdit={true}
                    />
                </div>
                <div className="gc-next-bar flat">

                </div>
            </div>
        );
    }
}